/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Event } from './Event';
import {
    EventFromJSON,
    EventFromJSONTyped,
    EventToJSON,
} from './Event';
import type { RemixContestsRelated } from './RemixContestsRelated';
import {
    RemixContestsRelatedFromJSON,
    RemixContestsRelatedFromJSONTyped,
    RemixContestsRelatedToJSON,
} from './RemixContestsRelated';

/**
 * 
 * @export
 * @interface RemixContestsResponse
 */
export interface RemixContestsResponse {
    /**
     * 
     * @type {Array<Event>}
     * @memberof RemixContestsResponse
     */
    data?: Array<Event>;
    /**
     * 
     * @type {RemixContestsRelated}
     * @memberof RemixContestsResponse
     */
    related?: RemixContestsRelated;
}

/**
 * Check if a given object implements the RemixContestsResponse interface.
 */
export function instanceOfRemixContestsResponse(value: object): value is RemixContestsResponse {
    let isInstance = true;

    return isInstance;
}

export function RemixContestsResponseFromJSON(json: any): RemixContestsResponse {
    return RemixContestsResponseFromJSONTyped(json, false);
}

export function RemixContestsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemixContestsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(EventFromJSON)),
        'related': !exists(json, 'related') ? undefined : RemixContestsRelatedFromJSON(json['related']),
    };
}

export function RemixContestsResponseToJSON(value?: RemixContestsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(EventToJSON)),
        'related': RemixContestsRelatedToJSON(value.related),
    };
}

